import './activeMessageItem.scss';
import activeMessageItemView from './activeMessageItemView.html';
import { GROWTH_ACTIVE_MESSAGE_WA_REPORT_BUTTON_CLICKED } from '../../GrowthSegmentEvents';
export class ActiveMessageItemController {
    static $inject = ['ActiveMessageService', 'GrowthSegmentService'];
    constructor(ActiveMessageService, GrowthSegmentService) {
        this.ActiveMessageService = ActiveMessageService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.isDownloading = false;
        this.total = 0;
        this.showProcessing = false;
    }
    async downloadCampaignReport() {
        this.isDownloading = true;
        this.ActiveMessageService.downloadCampaignReport(this.idCampaign, this.nameCampaign, (err) => {
            this.isDownloading = false;
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_REPORT_BUTTON_CLICKED, { status: err === undefined });
        });
    }
    hasFailReport() {
        return this.failed > 0;
    }
}
ActiveMessageItemController.$inject = ['ActiveMessageService', 'GrowthSegmentService'];
export const ActiveMessageItemComponent = {
    template: activeMessageItemView,
    controller: ActiveMessageItemController,
    controllerAs: '$ctrl',
    bindings: {
        idCampaign: '@?',
        nameCampaign: '@?',
        processed: '@?',
        received: '@?',
        read: '@?',
        failed: '@?',
        total: '@?',
        showProcessing: '@?',
    },
};
